import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const PSALogPage = lazy(() => import("./PSALogPage"));

const PSALogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <PSALogPage />
    </Suspense>
  );
};

export default PSALogPageLazy;
